export default "__VITE_ASSET__DCG0fQzE__"